// Logo da loja (P-126): a da identidade visual (painel, Minha Conta → Identidade) e, só quando a
// identidade não tiver logo, o arquivo antigo da empresa. Todo ponto que mostra a logo usa estas funções.
import { hideImageOnError } from "./imageFallback";

export function urlLogoAntiga(empresa) {
  return empresa?.url
    ? `${process.env.REACT_APP_API_URL}/companies/images/${empresa.url}/logos/logo.png`
    : null;
}

export function logoCabecalho(identidade, empresa) {
  return identidade?.logo_header || urlLogoAntiga(empresa);
}

export function logoRodape(identidade, empresa) {
  return identidade?.logo_rodape || urlLogoAntiga(empresa);
}

// onError da logo (P-124): tenta mais uma vez com um endereço novo (a api gera outro link assinado) antes de esconder.
export function erroLogo(event) {
  const img = event.currentTarget;
  if (!img.dataset.novaTentativa) {
    img.dataset.novaTentativa = "1";
    const src = img.getAttribute("src") || "";
    img.src = `${src}${src.includes("?") ? "&" : "?"}r=${Date.now()}`;
    return;
  }
  hideImageOnError(event);
}
